import { TableResponse } from "./shared_types";
export enum TaskStatus {
  TODO = "todo",
  IN_PROGRESS = "in_progress",
  HOLD = "hold",
  COMPLETED = "completed",
  ARCHIVED = "archived",
}

export enum TaskPriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export interface Comment {
  id: number;
  task_id: number;
  staff_id: string;
  comment: string;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
  is_deleted: boolean;
}
export interface LinkedTicket{
  ticket_id:number;
  reserved_number: string;
  assigned_number: string;
  ticket_number:string;
}

export interface Task {
  task_id: number;
  title: string;
  description: string;
  linked_ticket?: LinkedTicket;
  status: TaskStatus;
  priority: TaskPriority;
  assigned_to: string;
  created_at: string;
  due_date: string;
  created_by: string;
  updated_by: string;
  attachments: any[];
  comments: Comment[];
  tags: string[];
  is_deleted: boolean;
}

export type TasksTable = TableResponse<Task>;

export interface TaskCreationSchema {
  id: string;
  linked_ticket: any;
  title: string;
  description?: string;
  ticket_id?: string | null;
  status: TaskStatus;
  due_date: string;
  priority: TaskPriority;
  assigned_to?: string;
  created_at?: string;
  attachments?: string[];
  tags?: string[];
  task_id: number;
  created_by: string;
  updated_by: string;
  is_deleted: boolean;
  comments?: Comment[];
}

export interface LogEntryOfTask {
  id: number;
  task_id: number;
  field_name: string;
  updated_from: string | null;
  updated_to: string | null;
  action_date: string; // ISO timestamp
  action_by: string;
  type: string;
}